import { constant, fill, slice, times } from 'lodash';

/**
 * Fills an array with a given value up to a fixed length.
 * If the array is already longer than the desired length, it will be sliced.
 *
 * @param array - The array to fill
 * @param value - The value to fill the array with
 * @param length - The desired length of the array
 */
export function fixedLength<T>(array: T[] | null | undefined, value: T, length: number): T[] {
    if (!array) {
        return fill(Array(length), value);
    } else if (array.length >= length) {
        return slice(array, 0, length);
    }

    return [...array, ...times(length - array.length, constant(value)) ];
}
